/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReferenceMaterial } from '../../models/reference-material';

export interface ReferenceMaterialControllerFindAllForIls$Params {
  ilsId: string;
}

export function referenceMaterialControllerFindAllForIls(http: HttpClient, rootUrl: string, params: ReferenceMaterialControllerFindAllForIls$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ReferenceMaterial>>> {
  const rb = new RequestBuilder(rootUrl, referenceMaterialControllerFindAllForIls.PATH, 'get');
  if (params) {
    rb.path('ilsId', params.ilsId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ReferenceMaterial>>;
    })
  );
}

referenceMaterialControllerFindAllForIls.PATH = '/reference-material/for-ils/{ilsId}';
